import { createContext, useContext, useState, useCallback } from 'react';

const ToastContext = createContext(null);

const STYLES = {
  success: { borderColor: 'var(--success)', iconColor: 'var(--success)', icon: '✓' },
  error:   { borderColor: 'var(--danger)',  iconColor: 'var(--danger)',  icon: '✕' },
  info:    { borderColor: '#4a9eda',        iconColor: '#4a9eda',        icon: 'ℹ' },
};

function ToastItem({ item, onDismiss }) {
  const s = STYLES[item.variant] || STYLES.info;
  return (
    <div
      onClick={() => onDismiss(item.id)}
      style={{
        display: 'flex', alignItems: 'center', gap: '10px',
        padding: '10px 14px', borderRadius: '8px',
        background: 'var(--navy-mid)',
        border: `1px solid ${s.borderColor}55`,
        boxShadow: '0 4px 20px rgba(0,0,0,0.5)',
        cursor: 'pointer', minWidth: '200px', maxWidth: '300px',
        borderLeft: `3px solid ${s.borderColor}`,
      }}
    >
      <span style={{ color: s.iconColor, fontWeight: 700, fontSize: '0.85rem', flexShrink: 0 }}>{s.icon}</span>
      <span style={{ fontSize: '0.84rem', color: 'var(--text-primary)', lineHeight: 1.3 }}>{item.message}</span>
    </div>
  );
}

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  const dismiss = useCallback((id) => {
    setToasts(prev => prev.filter(t => t.id !== id));
  }, []);

  const toast = useCallback((message, variant = 'success') => {
    const id = Date.now() + Math.random();
    setToasts(prev => [...prev, { id, message, variant }]);
    setTimeout(() => dismiss(id), 3000);
  }, [dismiss]);

  return (
    <ToastContext.Provider value={{ toast }}>
      {children}
      <div style={{
        position: 'fixed', bottom: '24px', right: '24px',
        display: 'flex', flexDirection: 'column', gap: '8px',
        zIndex: 9999, pointerEvents: 'none',
      }}>
        {toasts.map(t => (
          <div key={t.id} style={{ pointerEvents: 'auto' }}>
            <ToastItem item={t} onDismiss={dismiss} />
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
}

export function useToast() {
  const ctx = useContext(ToastContext);
  if (!ctx) throw new Error('useToast must be used within ToastProvider');
  return ctx;
}
